// extracted by mini-css-extract-plugin
module.exports = {"abf-status-badge":"abf-status-badge___3qwVE"};